import { Button } from '../../../base/components/native/button'
import { Div } from '../../../base/components/native/div'
import ldb from '../../../base/lib/ldb'
import state from '../../../base/services/state'
import { waitFor } from '../../../base/utils/wait'
import { IProduct, IProductVariant } from '../../../interfaces/product'

export const SnipcartButton = (data: IProduct & IProductVariant) => {

    const base = Button()
    const hiddenButton = document.createElement('button')
    const [getDesign] = state.use<string>('design', ldb.get('design-url'))
    base.el.classList.add('snipcart-add-item')
    base.el.setAttribute('data-item-id', data.slug)
    base.el.setAttribute('data-item-price', '')
    base.el.setAttribute('data-item-url', location.host + data.url)
    base.el.setAttribute('data-item-description', data.description)
    base.el.setAttribute('data-item-design', getDesign())
    base.el.setAttribute('data-item-name', data.name)
    // base.el.setAttribute('data-item-custom1-name', options.custom1Name)
    // base.el.setAttribute('data-item-custom1-options', options.custom1Options)
    // base.el.setAttribute('data-item-custom1-image', '/images/h-r.jpg')

    hiddenButton.style.display = 'none'
    base.el.innerText = 'Add to cart'
    base.el.appendChild(hiddenButton)
    base.el.addEventListener('click', async (e) => {
        e.preventDefault()
        await waitFor(2000)
        console.log('click', data)
        // hiddenButton.click()
    })

    base.cssClass({
        border: 'none',
        marginTop: '10px',
        fontSize: '18px',
        backgroundColor: '#000',
        color: 'white',
        '&.disabled': {
            backgroundColor: '#000',
            color: '#fff'
        },
    })

    return Object.assign(base, {
        updateAttributes: (variant: IProductVariant) => {
            console.log('updateAttributes', variant);
            const name = data.name + ' (' + (variant.size || variant.color) + ')'
            base.el.setAttribute('data-item-name', name)
            base.el.setAttribute('data-item-image', variant.image)

            // base.el.setAttribute('data-item-design', variant.preview)
            base.el.setAttribute('data-item-url', location.host + data.url)
            base.el.setAttribute('data-item-price', variant.price || '')
            base.el.setAttribute('data-item-id', variant.slug)
        },
        disable: () => {
            base.el.setAttribute('disabled', 'true')
            base.el.classList.add('disabled')
        },
        enable: () => {
            base.el.removeAttribute('disabled')
            base.el.classList.remove('disabled')
        }
    })
}